import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSessionCheck } from "../../hooks/useSessionCheck";
import { AuthModel } from "../../services/models";
import { useAuth } from "../../context/AuthContext";
import SessionExpiredModal from "./SessionExpiredModal";

// Set to true to show modal, false to automatically redirect
const SHOW_MODAL_INSTEAD_OF_REDIRECT = false;

export default function SessionChecker() {
  const { isSessionExpired } = useSessionCheck();
  const navigate = useNavigate();
  const location = useLocation();
  const { toggleLogin } = useAuth();

  useEffect(() => {
    if (isSessionExpired && !SHOW_MODAL_INSTEAD_OF_REDIRECT) {
      // Don't redirect if already on login/signup/forgot-password pages
      const publicRoutes = ["/login", "/signup", "/forgot-password"];
      if (!publicRoutes.includes(location.pathname)) {
        // Clear auth data
        AuthModel.logout();
        toggleLogin(false);
        // Redirect to login page
        navigate("/login", { replace: true });
      }
    }
  }, [isSessionExpired, navigate, location.pathname, toggleLogin]);

  // Show modal if configured, otherwise redirect happens automatically
  if (SHOW_MODAL_INSTEAD_OF_REDIRECT) {
    const publicRoutes = ["/login", "/signup", "/forgot-password"];
    return (
      <SessionExpiredModal
        isOpen={
          isSessionExpired && !publicRoutes.includes(location.pathname)
        }
      />
    );
  }

  return null;
}

